import { PayloadAction, createSlice } from '@reduxjs/toolkit'

const initialState: any = []
const portsSlice = createSlice({
  name: 'ports',
  initialState,
  reducers: {
    updateListPorts: (state: any, action: PayloadAction<any>) => {
      return action.payload
    },
  },
})
export const portsAction = portsSlice.actions
export default portsSlice
